import apiClient from "../../../../helpers/api-client";
import { QuizWithProctoringOptions } from "../../assessments-page/assessments-page-helper";

export enum Status {
	Active = "active",
	Completed = "completed",
	Upcoming = "upcoming",
}

export type NonNullProctoringOptions = Omit<
	NonNullable<QuizWithProctoringOptions["proctoringOptions"]>,
	"candidateInterviewOptions"
> & {
	candidateInterviewOptions: NonNullable<
		NonNullable<QuizWithProctoringOptions["proctoringOptions"]>["candidateInterviewOptions"]
	>;
};

type NonNullQuizWithProctoringOptions = Omit<QuizWithProctoringOptions, "proctoringOptions"> & {
	proctoringOptions: NonNullProctoringOptions;
};

export type InterviewType = NonNullQuizWithProctoringOptions & {
	liveSession: SessionType;
};

export type AssessmentType = NonNullable<Awaited<ReturnType<typeof apiClient.assessment.getAssessmentByAssessmentId>>>;

export type CandidateOptionsType = NonNullable<
	NonNullable<Awaited<ReturnType<typeof apiClient.proctoringConfiguration.get>>>["candidateInterviewOptions"]
>;

export type ProctoringOptionsType = Omit<
	Awaited<ReturnType<typeof apiClient.proctoringConfiguration.get>>,
	"candidateInterviewOptions"
> & {
	candidateInterviewOptions: CandidateOptionsType;
};

export type SessionType = NonNullable<
	Awaited<ReturnType<typeof apiClient.liveClient.getLiveSessionsWithUsers>>["results"][number]
>;

export type SessionInfo = Exclude<
	Awaited<ReturnType<typeof apiClient.proctoringSession.getSessionList>>,
	null | undefined
>[0];
